module.exports = "/img/401.089007e7.gif";